import {IActionResponse, IUploadFileResponse} from "../../dal/BaseDAL";
import api from "../Api";
import {IGraphUser} from "../../models/GraphUser";
import {ArrayBufferToBase64} from "../../logic/ArrayBufferConverter";

const graphUserApi = api.injectEndpoints({
    endpoints: (build) => ({
        setUserImage: build.mutation<IUploadFileResponse, {username: string, request: { imageId: string, file: ArrayBuffer, imageType: string|null}}>({
            query: (arg) => ({
                url: `/graphUser/profileImage/${arg.username}`,
                method: "POST",
                body: {
                    file: ArrayBufferToBase64(arg.request.file),
                    fileName: `${arg.request.imageId}.png`,
                    imageType: arg.request.imageType ?? 'Default',
                }
            }),
        }),
        setMyUserImage: build.mutation<IUploadFileResponse, { imageId: string, file: ArrayBuffer, imageType: string|null}>({
            query: (arg) => ({
                url: `/graphUser/profileImage/my`,
                method: "POST",
                body: {
                    file: ArrayBufferToBase64(arg.file),
                    fileName: `${arg.imageId}.png`,
                    imageType: arg.imageType ?? 'Default',
                }
            }),
        }),
        patchGraphUser: build.mutation<IActionResponse, { username: string, request: Partial<IGraphUser> }>({
            query: (arg) => ({
                url: `/graphUser/${arg.username}/`,
                method: "PATCH",
                body: {updates: arg.request},
            }),
        }),
        patchMyGraphUser: build.mutation<IActionResponse, {request: Partial<IGraphUser> }>({
            query: (arg) => ({
                url: `/graphUser/my`,
                method: "PATCH",
                body: {updates: arg.request},
            }),
        }),
        getGraphUser: build.query<IGraphUser, { username: string}>({
            query: (arg) => ({
                url: `/graphUser/${arg.username}`,
                method: "GET"
            }),
        }),
        getMyGraphUser: build.query<IGraphUser, void>({
            query: () => ({
                url: `/graphUser/my`,
                method: "GET"
            }),
        })
    }),
});

export const {
    useSetUserImageMutation,
    useSetMyUserImageMutation,
    usePatchGraphUserMutation,
    usePatchMyGraphUserMutation,
    useGetGraphUserQuery,
    useGetMyGraphUserQuery
} = graphUserApi;